<template>
  <div class="aigc-check-container">
    <div class="aigc-check-page">
      <!-- 左侧配置面板 -->
      <div class="left-panel">
        <div class="panel-header">
          <div class="panel-title">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" class="panel-icon">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <span>AIGC 检测</span>
          </div>
          <button class="btn-history" @click="showHistoryDialog = true">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            历史数据
          </button>
        </div>

        <div class="panel-content">
          <!-- 使用次数显示 -->
          <div class="usage-info-card">
            <!-- 文本检测次数 -->
            <div v-if="activeTab === 'text'" class="usage-section">
              <div class="usage-header-row">
                <div class="usage-header-left">
                  <i class="el-icon-data-analysis"></i>
                  <span>今日使用情况</span>
                </div>
                <div class="usage-header-right">
                  <i class="el-icon-edit"></i>
                  <span>文本检测</span>
                </div>
              </div>
              <div class="usage-stats">
                <div class="usage-item">
                  <div class="usage-label">已使用</div>
                  <div class="usage-value primary">{{ usageInfo.textCount }}</div>
                </div>
                <div class="usage-divider"></div>
                <div class="usage-item">
                  <div class="usage-label">剩余</div>
                  <div class="usage-value" :class="getRemainingClass('text')">{{ usageInfo.textRemaining }}</div>
                </div>
                <div class="usage-divider"></div>
                <div class="usage-item">
                  <div class="usage-label">每日限额</div>
                  <div class="usage-value">{{ usageInfo.textLimit }}</div>
                </div>
              </div>
              <div class="usage-tip">
                <i class="el-icon-info"></i>
                <span v-if="usageInfo.textRemaining > 0">每日前 {{ pointsConfig.textFreeLimit }} 次免费，超出后每次消耗 {{
                    pointsConfig.textCheck
                  }} 积分</span>
                <span v-else style="color: #ffeb3b;">今日免费次数已用完，继续使用将消耗 {{
                    pointsConfig.textCheck
                  }} 积分/次</span>
              </div>
            </div>

            <!-- 文件检测次数 -->
            <div v-if="activeTab === 'file'" class="usage-section">
              <div class="usage-header-row">
                <div class="usage-header-left">
                  <i class="el-icon-data-analysis"></i>
                  <span>今日使用情况</span>
                </div>
                <div class="usage-header-right">
                  <i class="el-icon-document"></i>
                  <span>文件检测</span>
                </div>
              </div>
              <div class="usage-stats">
                <div class="usage-item">
                  <div class="usage-label">已使用</div>
                  <div class="usage-value primary">{{ usageInfo.fileCount }}</div>
                </div>
                <div class="usage-divider"></div>
                <div class="usage-item">
                  <div class="usage-label">剩余</div>
                  <div class="usage-value" :class="getRemainingClass('file')">{{ usageInfo.fileRemaining }}</div>
                </div>
                <div class="usage-divider"></div>
                <div class="usage-item">
                  <div class="usage-label">每日限额</div>
                  <div class="usage-value">{{ usageInfo.fileLimit }}</div>
                </div>
              </div>
              <div class="usage-tip">
                <i class="el-icon-info"></i>
                <span v-if="usageInfo.fileRemaining > 0">每日前 {{ pointsConfig.fileFreeLimit }} 次免费，超出后每次消耗 {{
                    pointsConfig.fileCheck
                  }} 积分</span>
                <span v-else style="color: #ffeb3b;">今日免费次数已用完，继续使用将消耗 {{
                    pointsConfig.fileCheck
                  }} 积分/次</span>
              </div>
            </div>
          </div>

          <!-- Tab 切换 -->
          <div class="mode-tabs">
            <div
                :class="['mode-tab', { active: activeTab === 'text' }]"
                @click="switchTab('text')"
            >
              <i class="el-icon-edit"></i>
              <span>文本检测</span>
            </div>
            <div
                :class="['mode-tab', { active: activeTab === 'file' }]"
                @click="switchTab('file')"
            >
              <i class="el-icon-document"></i>
              <span>文件检测</span>
            </div>
          </div>

          <!-- 文本检测 -->
          <div v-show="activeTab === 'text'" class="text-input-section">
            <div class="input-header">
              <span class="input-label">输入文本</span>
              <span class="char-count">{{ textInput.length }} / 1000</span>
            </div>
            <el-input
                type="textarea"
                v-model="textInput"
                placeholder="请输入或粘贴需要检测的文本内容..."
                :rows="8"
                maxlength="1000"
                show-word-limit
                :disabled="textChecking"
            ></el-input>

            <div class="action-buttons">
              <el-button
                  type="primary"
                  size="medium"
                  :loading="textChecking"
                  :disabled="!textInput.trim()"
                  @click="checkTextContent"
                  class="btn-check"
              >
                <i v-if="!textChecking" class="el-icon-search"></i>
                {{ textChecking ? '检测中...' : '开始检测' }}
              </el-button>
              <el-button
                  size="medium"
                  @click="clearTextInput"
                  :disabled="textChecking"
              >
                <i class="el-icon-delete"></i>
                清空
              </el-button>
            </div>
          </div>

          <!-- 文件检测 -->
          <div v-show="activeTab === 'file'" class="file-input-section">
            <el-upload
                class="upload-dragger"
                drag
                action="#"
                :auto-upload="false"
                :before-upload="beforeFileUpload"
                :on-change="handleFileChange"
                :show-file-list="false"
                accept=".docx"
                :disabled="fileChecking"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">拖拽文件到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip">仅支持 .docx 格式，大小不超过 50MB</div>
            </el-upload>

            <!-- 文件信息 -->
            <div v-if="selectedFile" class="file-info">
              <div class="file-details">
                <i class="el-icon-document"></i>
                <span class="file-name">{{ selectedFile.name }}</span>
                <span class="file-size">({{ formatFileSize(selectedFile.size) }})</span>
              </div>

              <!-- 课题名称和姓名输入框 -->
              <div class="form-inputs">
                <div class="form-item">
                  <label class="form-label">课题名称</label>
                  <el-input
                      v-model="paperTitle"
                      placeholder="请输入课题名称"
                      :disabled="fileChecking"
                      clearable
                  ></el-input>
                </div>
                <div class="form-item">
                  <label class="form-label">姓名</label>
                  <el-input
                      v-model="authorName"
                      placeholder="请输入姓名"
                      :disabled="fileChecking"
                      clearable
                  ></el-input>
                </div>
              </div>

              <div class="file-actions">
                <el-button
                    type="primary"
                    size="medium"
                    :loading="fileChecking"
                    :disabled="!selectedFile"
                    @click="checkFileContent"
                    class="btn-check"
                >
                  <i v-if="!fileChecking" class="el-icon-search"></i>
                  {{ fileChecking ? '检测中...' : '开始检测' }}
                </el-button>
                <el-button
                    size="medium"
                    @click="clearFile"
                    :disabled="fileChecking"
                >
                  <i class="el-icon-delete"></i>
                  清除
                </el-button>
              </div>

              <!-- 文件检测进度条 -->
              <div v-if="fileChecking || fileProgressPercent === 100" class="progress-container"
                   style="margin-top: 12px;">
                <div class="progress-info">
                  <span class="progress-text">{{ fileProgress || '准备中...' }}</span>
                  <span class="progress-percent">{{ fileProgressPercent }}%</span>
                </div>
                <el-progress
                    :percentage="fileProgressPercent"
                    :status="fileProgressPercent === 100 ? 'success' : null"
                    :show-text="false"
                ></el-progress>
              </div>
            </div>
          </div>

          <!-- 使用提示 -->
          <div class="tips-section">
            <h4>使用说明</h4>
            <ul>
              <li>文件检测：上传 .docx 格式的 Word 文档</li>
              <li>需填写课题名称和姓名信息</li>
              <li>课题名称会自动填充为文件名</li>
              <li>检测结果包含高、中、低三个风险等级</li>
              <li>支持中英文混合文本的检测分析</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 右侧结果面板 -->
      <div class="right-panel">
        <!-- 空状态 -->
        <div v-if="!currentResult" class="empty-state">
          <i class="el-icon-document-checked"></i>
          <p>检测结果将显示在这里</p>
          <span class="empty-hint">请在左侧输入文本或上传文件后开始检测</span>
        </div>

        <!-- 检测结果 -->
        <div v-else class="result-content">
          <!-- 结果头部 -->
          <div class="result-header">
            <div class="header-left">
              <h3>检测结果</h3>
              <span class="result-type">{{ activeTab === 'text' ? '文本检测' : '文件检测' }}</span>
            </div>
            <el-button
                v-if="activeTab === 'file'"
                type="primary"
                size="small"
                @click="downloadReport"
            >
              <i class="el-icon-download"></i>
              下载报告
            </el-button>
          </div>

          <!-- 视图模式切换 (仅文件检测显示) -->
          <div v-if="activeTab === 'file' && currentResult.htmlReport" class="view-mode-tabs">
            <div
                :class="['view-tab', { active: resultViewMode === 'details' }]"
                @click="switchResultView('details')"
            >
              <i class="el-icon-s-data"></i>
              <span>段落详情分析</span>
            </div>
            <div
                :class="['view-tab', { active: resultViewMode === 'html' }]"
                @click="switchResultView('html')"
            >
              <i class="el-icon-document"></i>
              <span>HTML 报告预览</span>
            </div>
          </div>

          <!-- HTML 报告预览 -->
          <div v-if="resultViewMode === 'html' && htmlBlobUrl" class="html-preview-section">
            <iframe
                ref="reportIframe"
                :src="htmlBlobUrl"
                class="html-iframe"
                frameborder="0"
                @load="onIframeLoad"
            ></iframe>
          </div>

          <!-- 段落详情分析 -->
          <div v-show="resultViewMode === 'details'">
            <!-- 文件信息 (仅文件检测显示) -->
            <div v-if="activeTab === 'file' && selectedFile" class="file-result-info">
              <div class="info-row">
                <span class="info-label">文件名：</span>
                <span class="info-value">{{ selectedFile.name }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">文档总字数：</span>
                <span class="info-value">{{ currentResult.doc_total_chars || 0 }} 字</span>
              </div>
              <div class="info-row">
                <span class="info-label">识别总字数：</span>
                <span class="info-value">{{ currentResult.text_for_detection_length || currentResult.total_chars || 0 }} 字</span>
              </div>
              <div class="info-row">
                <span class="info-label">AIGC 比例：</span>
                <span class="info-value aigc-percent" :class="getAigcPercentClass(aigcPercentage)">
                {{ aigcPercentage }}%
              </span>
              </div>
            </div>

            <!-- 段落详情 -->
            <div class="details-section">
              <h4 class="section-title">段落详情分析</h4>
              <div class="details-list">
                <div
                    v-for="(detail, index) in currentResult.details"
                    :key="index"
                    class="detail-item"
                >
                  <div class="detail-header">
                    <span class="detail-level">{{ detail.level }}</span>
                    <span class="detail-index">段落 {{ detail.para_index }}</span>
                    <span class="detail-risk" :class="getRiskClass(detail.para_risk)">{{
                        detail.para_risk ? (detail.para_risk * 100).toFixed(1) : 0
                      }}%</span>
                  </div>
                  <div class="detail-text">{{ detail.para_text }}</div>

                  <!-- 句子详情 -->
                  <div v-if="detail.sentence_details && detail.sentence_details.length > 0" class="sentence-details">
                    <div class="sentence-header">
                      <span>句子分析</span>
                    </div>
                    <div
                        v-for="(sent, sIndex) in detail.sentence_details"
                        :key="sIndex"
                        class="sentence-item"
                    >
                      <span class="sent-level">{{ sent.level }}</span>
                      <span class="sent-risk"
                            :class="getRiskClass(sent.risk)">{{ sent.risk ? (sent.risk * 100).toFixed(1) : 0 }}%</span>
                      <span class="sent-text">{{ sent.sentence }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 历史数据对话框 -->
    <el-dialog
        title="历史数据"
        :visible.sync="showHistoryDialog"
        width="70%"
        :close-on-click-modal="false"
        custom-class="history-dialog"
    >
      <div class="history-content">
        <!-- Tab切换 -->
        <el-tabs v-model="historyActiveTab" type="card">
          <!-- 文本检测历史 -->
          <el-tab-pane label="文本检测" name="text">
            <div v-if="textHistory.length === 0" class="empty-history">
              <i class="el-icon-document"></i>
              <p>暂无历史记录</p>
            </div>
            <div v-else>
              <!-- 表格展示 -->
              <el-table
                  :data="textHistory"
                  style="width: 100%"
                  stripe
                  :header-cell-style="{ background: '#f9fafb', color: '#374151', fontWeight: '600' }"
              >
                <el-table-column
                    prop="timestamp"
                    label="检测时间"
                    width="160"
                >
                </el-table-column>

                <el-table-column
                    label="文本内容"
                    min-width="200"
                >
                  <template slot-scope="scope">
                    <div class="table-text-preview">
                      {{ scope.row.textInput.substring(0, 50) }}{{ scope.row.textInput.length > 50 ? '...' : '' }}
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    prop="textLength"
                    label="字数"
                    width="100"
                    align="center"
                >
                  <template slot-scope="scope">
                    <span class="table-word-count">{{ scope.row.textLength }}</span>
                  </template>
                </el-table-column>

                <el-table-column
                    label="AIGC 比例"
                    width="120"
                    align="center"
                >
                  <template slot-scope="scope">
                  <span :class="['table-aigc-percent', getAigcPercentClass(scope.row.aigcPercentage)]">
                    {{ scope.row.aigcPercentage }}%
                  </span>
                  </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    width="180"
                    align="center"
                    fixed="right"
                >
                  <template slot-scope="scope">
                    <el-button
                        type="text"
                        size="small"
                        @click="loadTextHistory(scope.row)"
                    >
                      <i class="el-icon-view"></i> 查看
                    </el-button>
                    <el-button
                        type="text"
                        size="small"
                        style="color: #f56c6c;"
                        @click="deleteTextHistory(scope.$index)"
                    >
                      <i class="el-icon-delete"></i> 删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <!-- 文件检测历史 -->
          <el-tab-pane label="文件检测" name="file">
            <div v-if="fileHistory.length === 0" class="empty-history">
              <i class="el-icon-folder-opened"></i>
              <p>暂无历史记录</p>
            </div>
            <div v-else>
              <div class="history-list">
                <div
                    v-for="(item, index) in fileHistory"
                    :key="index"
                    class="history-item"
                >
                  <div class="history-item-header">
                    <div class="history-item-info">
                      <span class="history-time">{{ item.timestamp }}</span>
                      <span class="history-filename">{{ item.fileName }}</span>
                      <span class="history-words">{{ item.totalChars }} 字</span>
                      <span :class="['history-aigc', getAigcPercentClass(item.aigcPercentage)]">
                      AIGC: {{ item.aigcPercentage }}%
                    </span>
                    </div>
                    <div class="history-item-actions">
                      <el-button
                          type="primary"
                          size="mini"
                          @click="loadFileHistory(item)"
                      >
                        <i class="el-icon-view"></i> 查看
                      </el-button>
                      <el-button
                          type="danger"
                          size="mini"
                          icon="el-icon-delete"
                          @click="deleteFileHistory(index)"
                      >
                      </el-button>
                    </div>
                  </div>
                  <div class="history-file-stats">
                  <span class="stat-item">
                    <i class="el-icon-user"></i>
                    {{ item.authorName || '未知' }}
                  </span>
                    <span class="stat-item">
                    <i class="el-icon-document"></i>
                    {{ item.paperTitle || '未命名' }}
                  </span>
                    <span class="stat-item">
                    <i class="el-icon-tickets"></i>
                    共 {{ item.paragraphCount }} 个段落
                  </span>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {baseURL, getHeaders} from '@/utils/request'

export default {
  name: 'AigcCheck',
  data() {
    return {
      activeTab: 'file',
      baseURL: baseURL, // 添加 baseURL

      // 使用次数信息
      usageInfo: {
        textCount: 0,
        textRemaining: 10,
        textLimit: 10,
        fileCount: 0,
        fileRemaining: 2,
        fileLimit: 2
      },

      // 积分配置
      pointsConfig: {
        textCheck: 1,
        fileCheck: 1,
        textFreeLimit: 10,
        fileFreeLimit: 2
      },

      // 文本检测
      textInput: '',
      textChecking: false,
      textResult: null,

      // 文件检测
      selectedFile: null,
      fileChecking: false,
      fileResult: null,
      fileProgress: '', // 文件检测进度消息
      fileProgressPercent: 0, // 文件检测进度百分比

      // 文件检测表单
      paperTitle: '', // 课题名称
      authorName: '', // 姓名（默认为登录用户邮箱）

      // 结果展示模式切换
      resultViewMode: 'details', // 'details' 或 'html'
      htmlBlobUrl: null, // 用于 iframe 的 Blob URL

      // 历史记录相关
      showHistoryDialog: false,
      historyActiveTab: 'text',
      textHistory: [],
      fileHistory: []
    }
  },
  mounted() {
    // 页面访问统计
    this.increasePageView()
    // 页面加载时自动填充登录用户邮箱
    this.loadUserEmail()
    // 加载积分配置
    this.loadPointsConfig()
    // 加载使用次数信息
    this.loadUsageInfo()
    // 加载历史数据
    this.loadHistoryData()
  },
  beforeUnmount() {
    // 组件销毁时释放 Blob URL
    this.releaseBlobUrl()
  },
  computed: {
    currentResult() {
      return this.activeTab === 'text' ? this.textResult : this.fileResult
    },

    // 直接使用后端返回的 AIGC 百分比
    aigcPercentage() {
      if (!this.currentResult) {
        return '0.0'
      }
      // 优先使用后端计算好的百分比
      if (this.currentResult.aigcPercentage !== undefined) {
        return this.currentResult.aigcPercentage.toFixed(1)
      }
      // 兜底：如果后端没有返回,前端自己计算
      const totalChars = this.currentResult.doc_total_chars || this.currentResult.total_chars || 1
      const highRiskChars = this.currentResult.high_risk_chars || 0
      const percentage = (highRiskChars / totalChars) * 100
      return percentage.toFixed(1)
    }
  },
  methods: {
    // 页面访问统计
    increasePageView() {
      this.request.get('/pageView/increase', {
        params: { pageName: 'aigcCheck' }
      }).catch(() => {});
    },

    // 加载积分配置
    async loadPointsConfig() {
      try {
        const response = await this.request.get('/aigc/points-config')
        if (response.code === '200' && response.data) {
          this.pointsConfig = response.data
          console.log('积分配置:', this.pointsConfig)
        }
      } catch (error) {
        console.error('加载积分配置失败:', error)
      }
    },

    // 加载使用次数信息
    async loadUsageInfo() {
      try {
        const response = await this.request.get('/aigc/usage-count')
        if (response.code === '200' && response.data) {
          this.usageInfo = response.data
          console.log('使用次数信息:', this.usageInfo)
        }
      } catch (error) {
        console.error('加载使用次数失败:', error)
      }
    },

    // 加载当前登录用户的邮箱
    loadUserEmail() {
      try {
        const userStr = localStorage.getItem('user')
        if (userStr) {
          const user = JSON.parse(userStr)
          // 设置姓名为用户邮箱
          this.authorName = user.email || user.username || ''
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    },

    // 根据剩余次数返回样式类
    getRemainingClass(type) {
      const remaining = type === 'text' ? this.usageInfo.textRemaining : this.usageInfo.fileRemaining
      const limit = type === 'text' ? this.usageInfo.textLimit : this.usageInfo.fileLimit
      const percentage = (remaining / limit) * 100

      if (remaining === 0) {
        return 'danger'
      } else if (percentage <= 30) {
        return 'warning'
      } else {
        return 'success'
      }
    },

    // 切换 Tab
    switchTab(tab) {
      this.activeTab = tab
    },

    // 切换结果视图模式
    switchResultView(mode) {
      this.resultViewMode = mode

      // 切换到 HTML 预览时，创建 Blob URL
      if (mode === 'html' && this.currentResult && this.currentResult.htmlReport) {
        this.createHtmlBlobUrl(this.currentResult.htmlReport)
      }
    },

    // 创建 HTML Blob URL
    createHtmlBlobUrl(htmlContent) {
      // 清理旧的 Blob URL
      this.releaseBlobUrl()

      // 创建新的 Blob URL
      const blob = new Blob([htmlContent], {type: 'text/html;charset=utf-8'})
      this.htmlBlobUrl = URL.createObjectURL(blob)
    },

    // 释放 Blob URL
    releaseBlobUrl() {
      if (this.htmlBlobUrl) {
        URL.revokeObjectURL(this.htmlBlobUrl)
        this.htmlBlobUrl = null
      }
    },

    // iframe 加载完成后，注入居中样式
    onIframeLoad() {
      try {
        const iframe = this.$refs.reportIframe
        if (iframe && iframe.contentDocument) {
          const iframeDoc = iframe.contentDocument
          const body = iframeDoc.body

          if (body) {
            // 注入居中样式
            const style = iframeDoc.createElement('style')
            style.textContent = `
              body {
                display: flex !important;
                justify-content: center !important;
                align-items: flex-start !important;
                min-height: 100vh !important;
                margin: 0 !important;
                padding: 20px !important;
                background: #f5f5f5 !important;
                box-sizing: border-box !important;
              }
              body > * {
                max-width: 1200px !important;
                width: 100% !important;
                background: white !important;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
              }
            `
            iframeDoc.head.appendChild(style)
          }
        }
      } catch (error) {
        // 跨域问题会导致访问 contentDocument 失败，这是正常的
        console.log('无法访问 iframe 内容（可能是跨域限制）')
      }
    },

    // ========== 文本检测 ==========
    async checkTextContent() {
      if (!this.textInput.trim()) {
        this.$message.warning('请输入文本内容')
        return
      }

      // 记录检测前的剩余次数
      const remainingBeforeCheck = this.usageInfo.textRemaining

      // 检查是否需要消耗积分
      if (remainingBeforeCheck === 0) {
        try {
          await this.$confirm(
              `今日文本检测免费次数已用完，继续操作将消耗 ${this.pointsConfig.textCheck} 积分，是否继续？`,
              '积分消耗提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
          )
        } catch {
          // 用户取消
          return
        }
      }

      this.textChecking = true
      this.textResult = null

      try {
        const formData = new FormData()
        formData.append('text', this.textInput)

        const response = await this.request.post('/aigc/check-text', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        if (response.success) {
          this.textResult = response
          this.$message.success('检测完成')
          // 保存到历史记录
          this.saveTextHistory()
          // 刷新使用次数
          this.loadUsageInfo()
          // 如果消耗了积分（之前剩余次数为0），刷新顶部积分显示
          if (remainingBeforeCheck === 0) {
            this.$refreshPoints()
          }
        } else {
          this.$message.error(response.error || '检测失败')
        }
      } catch (error) {
        console.error('检测失败:', error)
        this.$message.error(error.message || '检测失败，请检查服务是否正常运行')
      } finally {
        this.textChecking = false
      }
    },

    clearTextInput() {
      this.textInput = ''
      this.textResult = null
    },

    // ========== 文件检测 ==========
    beforeFileUpload(file) {
      const isDocx = file.name.toLowerCase().endsWith('.docx')
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isDocx) {
        this.$message.error('只支持 .docx 格式的文档')
        return false
      }
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB')
        return false
      }

      return false // 阻止自动上传
    },

    handleFileChange(file) {
      if (file.raw) {
        this.selectedFile = file.raw
        this.fileResult = null

        // 自动填充课题名称为文件名（去掉扩展名）
        const fileName = file.raw.name
        this.paperTitle = fileName.replace(/\.[^/.]+$/, '') // 去掉扩展名

        this.$message.success('文件已选择：' + file.raw.name)
      }
    },

    async checkFileContent() {
      if (!this.selectedFile) {
        this.$message.warning('请先选择文件')
        return
      }

      // 验证课题名称和姓名
      if (!this.paperTitle.trim()) {
        this.$message.warning('请输入课题名称')
        return
      }

      if (!this.authorName.trim()) {
        this.$message.warning('请输入姓名')
        return
      }

      // 记录检测前的剩余次数
      const remainingBeforeCheck = this.usageInfo.fileRemaining

      // 检查是否需要消耗积分
      if (remainingBeforeCheck === 0) {
        try {
          await this.$confirm(
              `今日文件检测免费次数已用完，继续操作将消耗 ${this.pointsConfig.fileCheck} 积分，是否继续？`,
              '积分消耗提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
          )
        } catch {
          // 用户取消
          return
        }
      }

      this.fileChecking = true
      this.fileResult = null
      this.fileProgress = '准备上传文件...'
      this.fileProgressPercent = 0

      try {
        const formData = new FormData()
        formData.append('file', this.selectedFile)

        // 使用已封装的 baseURL 和 headers
        const headers = getHeaders()
        delete headers['Content-Type'] // FormData 会自动设置正确的 Content-Type

        // 使用 fetch 发送 POST 请求到 Java 并接收流
        const response = await fetch(`${baseURL}/aigc/check-file-sse`, {
          method: 'POST',
          headers: headers,
          body: formData
        })

        if (!response.ok) {
          throw new Error('请求失败')
        }

        this.fileProgressPercent = 5

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let buffer = ''
        let currentEvent = '' // 记录当前事件类型

        while (true) {
          const {done, value} = await reader.read()
          if (done) {
            break
          }

          buffer += decoder.decode(value, {stream: true})
          const lines = buffer.split('\n')

          // 保留最后一个不完整的行
          buffer = lines.pop() || ''

          for (const line of lines) {
            if (line.trim() === '') {
              // 空行表示一个消息结束，重置事件类型
              currentEvent = ''
              continue
            }

            // SSE 格式：event: xxx 或 data: xxx
            if (line.startsWith('event:')) {
              currentEvent = line.substring(6).trim()
            } else if (line.startsWith('data:')) {
              try {
                const jsonStr = line.substring(5).trim()
                const data = JSON.parse(jsonStr)

                // 根据事件类型或数据内容处理
                if (currentEvent === 'result' || data.type === 'result' || data.success !== undefined) {
                  // 最终结果
                  this.fileResult = data
                  this.fileProgress = '检测完成！'
                  this.fileProgressPercent = 100
                  this.$message.success('检测完成')

                  // 如果有 HTML 报告，创建 Blob URL
                  if (data.htmlReport) {
                    this.createHtmlBlobUrl(data.htmlReport)
                  }
                } else if (currentEvent === 'progress' || data.step) {
                  // 进度消息 - 根据步骤设置百分比
                  this.fileProgress = data.message
                  this.updateProgressPercent(data.step)
                } else if (currentEvent === 'error' || data.error) {
                  // 错误消息
                  console.error('❌ 收到错误:', data.error || data.message)
                  this.$message.error(data.error || data.message || '检测失败')
                } else {
                  console.warn('⚠️ 未知消息类型:', data)
                }
              } catch (e) {
                console.error('❌ 解析数据失败:', e, '原始数据:', line)
              }
            }
          }
        }

        // 处理最后的 buffer
        if (buffer && buffer.trim()) {
          if (buffer.startsWith('data:')) {
            try {
              const jsonStr = buffer.substring(5).trim()
              const data = JSON.parse(jsonStr)

              // 最终结果
              if (data.success !== undefined) {
                this.fileResult = data
                this.fileProgress = '检测完成！'
                this.fileProgressPercent = 100
                this.$message.success('检测完成')
              }
            } catch (e) {
              console.error('解析最后数据失败:', e, '原始数据:', buffer)
            }
          }
        }

        // 如果流读取完成但没有收到结果，提示用户
        if (!this.fileResult) {
          this.$message.warning('未收到检测结果，请重试')
          this.fileProgressPercent = 0
        } else {
          // 检测成功后保存到历史记录
          this.saveFileHistory()
          // 检测成功后刷新使用次数
          this.loadUsageInfo()
          // 如果消耗了积分（之前剩余次数为0），刷新顶部积分显示
          if (remainingBeforeCheck === 0) {
            this.$refreshPoints()
          }
        }

      } catch (error) {
        console.error('检测失败:', error)
        this.$message.error(error.message || '检测失败，请检查服务是否正常运行')
        this.fileProgressPercent = 0
      } finally {
        this.fileChecking = false
        // 不清空进度，保持100%显示
      }
    },

    // 根据步骤更新进度百分比
    updateProgressPercent(step) {
      const progressMap = {
        'start': 10,
        'parsing': 15,
        'detecting': 20,
        'init': 25,
        'paragraphs': 30,
        'splitting': 35,
        'sentences': 40,
        'language': 45,
        'model_zh': 50,
        'detecting_zh': 60,
        'zh_done': 70,
        'model_en': 72,
        'detecting_en': 80,
        'en_done': 85,
        'inference_done': 90,
        'aggregating': 93,
        'completed': 95
      }

      const percent = progressMap[step]
      if (percent !== undefined && percent > this.fileProgressPercent) {
        this.fileProgressPercent = percent
      }
    },

    clearFile() {
      this.selectedFile = null
      this.fileResult = null
      this.fileProgress = ''
      this.fileProgressPercent = 0
      this.paperTitle = ''
      this.authorName = ''
      this.resultViewMode = 'details'
      this.releaseBlobUrl()
    },

    clearResult() {
      if (this.activeTab === 'text') {
        this.textResult = null
      } else {
        this.fileResult = null
        this.releaseBlobUrl()
      }
      this.resultViewMode = 'details'
    },

    // 根据 AIGC 百分比返回样式类
    getAigcPercentClass(percentage) {
      const percent = parseFloat(percentage)
      if (percent > 70) {
        return 'percent-high'
      } else if (percent > 60) {
        return 'percent-mid'
      } else {
        return 'percent-low'
      }
    },

    // 根据风险值返回样式类（用于段落和句子的百分比显示）
    getRiskClass(risk) {
      if (!risk) return 'risk-low'
      const percent = risk * 100
      if (percent > 70) {
        return 'risk-high'
      } else if (percent > 60) {
        return 'risk-mid'
      } else {
        return 'risk-low'
      }
    },

    // 下载报告（ZIP 压缩包，包含 HTML 和 MD）
    async downloadReport() {
      if (!this.fileResult || !this.fileResult.success) {
        this.$message.warning('没有可下载的报告')
        return
      }

      try {
        // 检查返回结果中是否有报告路径
        if (!this.fileResult.reportPath) {
          throw new Error('报告路径不存在')
        }

        // 使用 axios 发送 GET 请求下载 ZIP 文件
        const response = await this.request.get('/aigc/download-report', {
          params: {
            filePath: this.fileResult.reportPath
          },
          responseType: 'blob' // 重要：设置响应类型为 blob
        })

        // 生成默认文件名
        let fileName = `AIGC检测报告_${this.paperTitle || '未命名'}_${Date.now()}.zip`

        // 尝试从响应头获取文件名（可选）
        if (response && response.headers) {
          const contentDisposition = response.headers['content-disposition']
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (fileNameMatch && fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''))
            }
          }
        }

        // 创建 Blob 对象和下载链接
        const blob = new Blob([response.data], {type: 'application/zip'})
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$message.success('报告下载完成（包含 HTML 和 Markdown 格式）')
      } catch (error) {
        console.error('报告下载失败:', error)
        this.$message.error('报告下载失败: ' + (error.message || '未知错误'))
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 B'
      const k = 1024
      const sizes = ['B', 'KB', 'MB', 'GB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },

    // ==================== 历史记录相关方法 ====================

    // 加载历史数据
    loadHistoryData() {
      try {
        const textHistoryStr = localStorage.getItem('aigcCheck_textHistory')
        const fileHistoryStr = localStorage.getItem('aigcCheck_fileHistory')

        this.textHistory = textHistoryStr ? JSON.parse(textHistoryStr) : []
        this.fileHistory = fileHistoryStr ? JSON.parse(fileHistoryStr) : []
      } catch (error) {
        console.error('加载历史数据失败:', error)
        this.textHistory = []
        this.fileHistory = []
      }
    },

    // 保存文本检测历史
    saveTextHistory() {
      if (!this.textResult || !this.textResult.success) {
        return
      }

      try {
        // 创建精简版的结果数据（不包含过大的字段）
        const slimResult = {
          success: this.textResult.success,
          total_chars: this.textResult.total_chars,
          high_risk_chars: this.textResult.high_risk_chars,
          medium_risk_chars: this.textResult.medium_risk_chars,
          low_risk_chars: this.textResult.low_risk_chars,
          aigcPercentage: this.textResult.aigcPercentage,
          details: this.textResult.details // 保留详情
        }

        const historyItem = {
          timestamp: new Date().toLocaleString('zh-CN'),
          textInput: this.textInput,
          textLength: this.textInput.length,
          result: slimResult,
          aigcPercentage: this.aigcPercentage
        }

        // 添加到历史记录开头
        this.textHistory.unshift(historyItem)

        // 只保留最近 20 条记录
        if (this.textHistory.length > 20) {
          this.textHistory = this.textHistory.slice(0, 20)
        }

        // 保存到 localStorage
        try {
          localStorage.setItem('aigcCheck_textHistory', JSON.stringify(this.textHistory))
          console.log('文本检测历史已保存，当前记录数：', this.textHistory.length)
        } catch (storageError) {
          console.error('localStorage 存储失败，可能超出容量限制:', storageError)
          // 如果存储失败，尝试删除最旧的记录后重试
          if (this.textHistory.length > 1) {
            this.textHistory = this.textHistory.slice(0, 10) // 只保留最近10条
            localStorage.setItem('aigcCheck_textHistory', JSON.stringify(this.textHistory))
            console.log('已清理旧记录，重新保存')
          }
        }
      } catch (error) {
        console.error('保存文本检测历史失败:', error)
      }
    },

    // 保存文件检测历史
    saveFileHistory() {
      if (!this.fileResult || !this.fileResult.success) {
        return
      }

      try {
        // 创建精简版的结果数据（移除巨大的 htmlReport 字段以节省空间）
        const slimResult = {
          success: this.fileResult.success,
          total_chars: this.fileResult.total_chars,
          doc_total_chars: this.fileResult.doc_total_chars,
          text_for_detection_length: this.fileResult.text_for_detection_length,
          high_risk_chars: this.fileResult.high_risk_chars,
          medium_risk_chars: this.fileResult.medium_risk_chars,
          low_risk_chars: this.fileResult.low_risk_chars,
          aigcPercentage: this.fileResult.aigcPercentage,
          total_paragraphs: this.fileResult.total_paragraphs,
          details: this.fileResult.details, // 保留详情
          reportPath: this.fileResult.reportPath // 保留报告路径
          // 注意：不保存 htmlReport，因为太大了
        }

        const historyItem = {
          timestamp: new Date().toLocaleString('zh-CN'),
          fileName: this.selectedFile.name,
          fileSize: this.selectedFile.size,
          paperTitle: this.paperTitle,
          authorName: this.authorName,
          result: slimResult,
          aigcPercentage: this.aigcPercentage,
          totalChars: this.fileResult.doc_total_chars || 0,
          paragraphCount: this.fileResult.total_paragraphs || 0
        }

        // 添加到历史记录开头
        this.fileHistory.unshift(historyItem)

        // 只保留最近 10 条记录（文件检测数据较大）
        if (this.fileHistory.length > 10) {
          this.fileHistory = this.fileHistory.slice(0, 10)
        }

        // 保存到 localStorage
        try {
          localStorage.setItem('aigcCheck_fileHistory', JSON.stringify(this.fileHistory))
          console.log('文件检测历史已保存，当前记录数：', this.fileHistory.length)
        } catch (storageError) {
          console.error('localStorage 存储失败，可能超出容量限制:', storageError)
          // 如果存储失败，尝试只保留最近5条
          if (this.fileHistory.length > 1) {
            this.fileHistory = this.fileHistory.slice(0, 5)
            localStorage.setItem('aigcCheck_fileHistory', JSON.stringify(this.fileHistory))
            console.log('已清理旧记录，重新保存')
          }
        }
      } catch (error) {
        console.error('保存文件检测历史失败:', error)
      }
    },

    // 加载文本历史记录
    loadTextHistory(item) {
      this.$confirm('加载历史记录将覆盖当前内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 切换到文本检测 Tab
        this.activeTab = 'text'

        // 加载数据
        this.textInput = item.textInput
        this.textResult = item.result

        // 关闭对话框
        this.showHistoryDialog = false

        this.$message.success('历史记录已加载')
      }).catch(() => {
      })
    },

    // 加载文件历史记录
    loadFileHistory(item) {
      this.$confirm('查看历史记录将覆盖当前内容，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 切换到文件检测 Tab
        this.activeTab = 'file'

        // 加载数据
        this.fileResult = item.result
        this.paperTitle = item.paperTitle
        this.authorName = item.authorName

        // 创建一个虚拟文件对象用于显示
        this.selectedFile = {
          name: item.fileName,
          size: item.fileSize
        }

        // 因为历史记录中没有保存 htmlReport（太大），所以只能显示段落详情
        // 清除之前的 HTML Blob URL
        this.releaseBlobUrl()
        
        // 强制切换到段落详情视图
        this.resultViewMode = 'details'

        // 关闭对话框
        this.showHistoryDialog = false

        this.$message.success('历史记录已加载（注意：历史记录不包含 HTML 报告预览）')
      }).catch(() => {
      })
    },

    // 删除文本历史记录
    deleteTextHistory(index) {
      this.$confirm('确定要删除这条历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.textHistory.splice(index, 1)
        localStorage.setItem('aigcCheck_textHistory', JSON.stringify(this.textHistory))
        this.$message.success('历史记录已删除')
      }).catch(() => {
      })
    },

    // 删除文件历史记录
    deleteFileHistory(index) {
      this.$confirm('确定要删除这条历史记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileHistory.splice(index, 1)
        localStorage.setItem('aigcCheck_fileHistory', JSON.stringify(this.fileHistory))
        this.$message.success('历史记录已删除')
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.aigc-check-container {
  /* 最外层容器，不添加任何样式，只作为根元素 */
}

.aigc-check-page {
  display: flex;
  height: calc(100vh - 118px);
  background: #f5f5f5;
  overflow: hidden;
}

/* ========== 左侧面板 ========== */
.left-panel {
  width: 380px;
  background: #fff;
  border-right: none;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.panel-header {
  padding: 12px 24px;
  border-bottom: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  line-height: 1;
}

.panel-title span {
  line-height: 1;
}

.panel-icon {
  width: 20px;
  height: 20px;
  color: #4f46e5;
}

.btn-history {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  color: #4f46e5;
  background: #fff;
  border: 1px solid #4f46e5;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-history:hover {
  background: #4f46e5;
  color: #fff;
}

.btn-history svg {
  width: 16px;
  height: 16px;
}

.panel-content {
  padding: 20px;
  flex: 1;
}

/* ========== 使用次数卡片 ========== */
.usage-info-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 0;
  padding: 16px;
  margin-bottom: 24px;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.usage-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.usage-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.usage-header-left i {
  font-size: 18px;
}

.usage-header-right {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 0;
}

.usage-header-right i {
  font-size: 14px;
}

.usage-section {
  /* 不需要 margin-bottom，因为只显示一个 section */
}

.usage-stats {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 0;
  padding: 10px 12px;
  backdrop-filter: blur(10px);
}

.usage-item {
  text-align: center;
  flex: 1;
}

.usage-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 4px;
}

.usage-value {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  line-height: 1;
}

.usage-value.primary {
  color: #ffd700;
}

.usage-value.success {
  color: #4ade80;
}

.usage-value.warning {
  color: #fbbf24;
}

.usage-value.danger {
  color: #ff6b6b;
}

.usage-divider {
  width: 1px;
  height: 30px;
  background: rgba(255, 255, 255, 0.2);
}

.usage-tip {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.6;
  background: rgba(255, 255, 255, 0.1);
  padding: 10px 12px;
  border-radius: 0;
  margin-top: 10px;
}

.usage-tip i {
  font-size: 15px;
  flex-shrink: 0;
  margin-top: 2px;
}

/* Tab 切换 */
.mode-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.mode-tab {
  flex: 1;
  padding: 10px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  color: #6b7280;
  border-radius: 0;
}

.mode-tab:hover {
  background: #f5f3ff;
  border-color: #8c6ff7;
  color: #8c6ff7;
}

.mode-tab.active {
  background: #8c6ff7;
  border-color: #8c6ff7;
  color: #fff;
  box-shadow: 0 2px 8px rgba(140, 111, 247, 0.3);
}

.mode-tab i {
  font-size: 16px;
}

/* 进度容器 */
.progress-container {
  margin-top: 12px;
  padding: 12px 16px;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.progress-text {
  font-size: 13px;
  color: #0c4a6e;
  font-weight: 500;
}

.progress-percent {
  font-size: 14px;
  color: #0369a1;
  font-weight: 600;
}

/* 进度提示（旧样式，保留兼容） */
.progress-tip {
  margin-top: 12px;
  padding: 10px 16px;
  background: #f0f9ff;
  border: 1px solid #bfdbfe;
  border-radius: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1e40af;
}

.progress-tip i {
  font-size: 16px;
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 文本输入 */
.text-input-section {
  animation: fadeIn 0.3s;
}

.input-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.input-label {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.char-count {
  font-size: 13px;
  color: #9ca3af;
}

.text-input-section >>> .el-textarea__inner {
  font-size: 14px;
  line-height: 1.8;
  border: 2px solid #e5e7eb;
  transition: all 0.3s;
  resize: none;
  white-space: pre-wrap;
  word-wrap: break-word;
  border-radius: 0 !important;
}

.text-input-section >>> .el-textarea__inner:focus {
  border-color: #8c6ff7;
}

.action-buttons {
  margin-top: 16px;
  display: flex;
  gap: 8px;
}

.action-buttons .el-button {
  flex: 1;
  padding: 10px 20px;
  font-size: 14px;
  height: auto;
  border-radius: 0 !important;
}

.btn-check {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
}

.btn-check:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
}

/* 文件上传 */
.file-input-section {
  animation: fadeIn 0.3s;
}

.upload-dragger {
  margin-bottom: 16px;
}

.upload-dragger >>> .el-upload {
  width: 100%;
}

.upload-dragger >>> .el-upload-dragger {
  width: 100%;
  height: 120px;
  border-radius: 0 !important;
  border: 2px dashed #d1d5db;
  background: #fafafa;
  transition: all 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-dragger >>> .el-upload-dragger:hover {
  border-color: #2563eb;
  background: #f0f4ff;
}

.upload-dragger >>> .el-icon-upload {
  font-size: 40px;
  color: #9ca3af;
  margin: 0 0 8px 0;
}

.upload-dragger >>> .el-upload__text {
  font-size: 14px;
  color: #374151;
  margin: 0;
}

.upload-dragger >>> .el-upload__text em {
  color: #2563eb;
  font-weight: 600;
}

.upload-dragger >>> .el-upload__tip {
  font-size: 12px;
  color: #9ca3af;
  margin-top: 8px;
}

.file-info {
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  margin-bottom: 16px;
}

.file-details {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-size: 14px;
  color: #111827;
}

.file-details i {
  font-size: 20px;
  color: #2563eb;
}

.file-name {
  font-weight: 600;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-size {
  color: #6b7280;
}

/* 表单输入框 */
.form-inputs {
  margin-bottom: 16px;
}

.form-item {
  margin-bottom: 12px;
}

.form-item:last-child {
  margin-bottom: 0;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.form-item >>> .el-input__inner {
  border-radius: 0;
  font-size: 14px;
}

.file-actions {
  display: flex;
  gap: 8px;
}

.file-actions .el-button {
  flex: 1;
  padding: 10px 20px;
  font-size: 14px;
  height: auto;
  border-radius: 0 !important;
}

/* 使用提示 */
.tips-section {
  margin-top: 32px;
  padding: 16px;
  background: #fffbeb;
  border: 1px solid #fbbf24;
  border-radius: 0;
}

.tips-section h4 {
  font-size: 14px;
  font-weight: 600;
  color: #92400e;
  margin: 0 0 8px 0;
}

.tips-section ul {
  margin: 0;
  padding-left: 20px;
  list-style: disc;
}

.tips-section li {
  font-size: 13px;
  color: #78350f;
  line-height: 1.6;
  margin-bottom: 4px;
}

/* ========== 右侧面板 ========== */
.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background: #fff;
  padding: 24px;
  margin-left: 10px;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  color: #9ca3af;
}

.empty-state i {
  font-size: 80px;
  margin-bottom: 16px;
}

.empty-state p {
  font-size: 18px;
  font-weight: 500;
  color: #6b7280;
  margin: 0 0 8px 0;
}

.empty-hint {
  font-size: 14px;
  color: #9ca3af;
}

/* 结果内容 */
.result-content {
  animation: fadeIn 0.3s;
  flex: 1;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.result-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
}

.result-type {
  padding: 4px 12px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 12px;
  font-weight: 600;
  border-radius: 0;
}

/* 视图模式切换 */
.view-mode-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  padding: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.view-tab {
  flex: 1;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #6b7280;
  border-radius: 0;
}

.view-tab:hover {
  background: #f0f4ff;
  border-color: #2563eb;
  color: #2563eb;
}

.view-tab.active {
  background: #2563eb;
  border-color: #2563eb;
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
}

.view-tab i {
  font-size: 16px;
}

/* HTML 报告预览 */
.html-preview-section {
  width: 100%;
  height: calc(100vh - 280px);
  border: 1px solid #e5e7eb;
  background: #f5f5f5;
  overflow: auto;
}

.html-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* 文件信息 */
.file-result-info {
  margin-bottom: 24px;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #6b7280;
  font-weight: 500;
}

.info-value {
  color: #111827;
  font-weight: 600;
}

.info-tip {
  color: #9ca3af;
  font-size: 12px;
  margin-left: 8px;
}

/* AIGC 百分比样式 */
.aigc-percent {
  font-size: 16px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
}

.percent-high {
  color: #ef4444;
  background: #fee2e2;
}

.percent-mid {
  color: #f59e0b;
  background: #fef3c7;
}

.percent-low {
  color: #10b981;
  background: #d1fae5;
}

/* 段落详情 */
.details-section {
  margin-top: 32px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.details-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.detail-item {
  padding: 16px;
  background: #fafafa;
  border-left: 4px solid #2563eb;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.detail-level {
  font-size: 20px;
}

.detail-index {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.detail-risk {
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
}

/* 段落和句子风险等级颜色 */
.risk-high {
  color: #ef4444;
  background: #fee2e2;
}

.risk-mid {
  color: #f59e0b;
  background: #fef3c7;
}

.risk-low {
  color: #10b981;
  background: #d1fae5;
}

.detail-text {
  font-size: 14px;
  line-height: 1.8;
  color: #374151;
  padding: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  margin-bottom: 12px;
}

/* 句子详情 */
.sentence-details {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
}

.sentence-header {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
}

.sentence-item {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 8px;
  margin-bottom: 6px;
  background: #fff;
  border: 1px solid #f3f4f6;
  font-size: 13px;
}

.sentence-item:last-child {
  margin-bottom: 0;
}

.sent-level {
  font-size: 16px;
  flex-shrink: 0;
}

.sent-risk {
  padding: 2px 6px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
  border-radius: 0;
}

.sent-text {
  flex: 1;
  color: #374151;
  line-height: 1.6;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 滚动条样式 */
.left-panel::-webkit-scrollbar,
.right-panel::-webkit-scrollbar {
  width: 6px;
}

.left-panel::-webkit-scrollbar-track,
.right-panel::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.left-panel::-webkit-scrollbar-thumb,
.right-panel::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 0;
}

.left-panel::-webkit-scrollbar-thumb:hover,
.right-panel::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* ========== 历史数据对话框样式 ========== */
.history-dialog >>> .el-dialog {
  border-radius: 0;
}

.history-dialog >>> .el-dialog__header {
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 20px;
}

.history-dialog >>> .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.history-content {
  padding: 0;
}

.history-content >>> .el-tabs__header {
  margin: 0;
  background: #fff;
}

.history-content >>> .el-tabs__item {
  height: 42px;
  line-height: 42px;
  font-size: 14px;
}

/* 空状态 */
.empty-history {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #9ca3af;
}

.empty-history i {
  font-size: 64px;
  margin-bottom: 16px;
  color: #d1d5db;
}

.empty-history p {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
}

/* 表格样式 */
.table-text-preview {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
}

.table-word-count {
  font-weight: 600;
  color: #111827;
}

.table-aigc-percent {
  padding: 4px 8px;
  border-radius: 0;
  font-weight: 600;
  font-size: 12px;
}

/* 文件历史列表 */
.history-list {
  padding: 16px;
}

.history-item {
  background: #fff;
  border: 1px solid #e5e7eb;
  padding: 16px;
  margin-bottom: 16px;
  transition: all 0.2s;
}

.history-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-color: #d1d5db;
}

.history-item:last-child {
  margin-bottom: 0;
}

.history-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.history-item-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  flex: 1;
}

.history-time {
  font-size: 13px;
  color: #6b7280;
}

.history-filename {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-words {
  font-size: 13px;
  color: #6b7280;
  padding: 2px 8px;
  background: #f3f4f6;
  border-radius: 0;
}

.history-aigc {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 0;
}

.history-item-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.history-file-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #6b7280;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.stat-item i {
  color: #9ca3af;
}

.stat-warning {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f59e0b;
}

.stat-warning i {
  color: #f59e0b;
}

/* 分页 */
.history-pagination {
  padding: 16px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #e5e7eb;
  background: #f9fafb;
}

/* 详情对话框 */
.detail-dialog >>> .el-dialog {
  border-radius: 0;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.detail-dialog >>> .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.detail-header {
  background: #f9fafb;
  padding: 16px;
  border: 1px solid #e5e7eb;
}

.detail-info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 14px;
}

.detail-info-row:last-child {
  margin-bottom: 0;
}

.detail-label {
  color: #6b7280;
  font-weight: 500;
}

.detail-value {
  color: #111827;
  font-weight: 600;
}

.detail-text-section {
  border: 1px solid #e5e7eb;
}

.detail-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.detail-section-header h4 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.detail-text-content {
  padding: 16px;
  font-size: 14px;
  line-height: 1.8;
  color: #374151;
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-word;
}

.detail-stats-section {
  border: 1px solid #e5e7eb;
  padding: 16px;
}

.detail-stats-section h4 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
}

.detail-stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.stat-card {
  text-align: center;
  padding: 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}

.stat-value.high {
  color: #ef4444;
}

.stat-value.mid {
  color: #f59e0b;
}

.stat-value.low {
  color: #10b981;
}

/* ==================== 历史记录对话框样式 ==================== */
.history-dialog >>> .el-dialog__body {
  padding: 0;
}

.history-content {
  min-height: 400px;
  max-height: 600px;
}

.history-content >>> .el-tabs__header {
  margin: 0;
}

.history-content >>> .el-tabs__content {
  padding: 20px;
  max-height: 500px;
  overflow-y: auto;
}

.empty-history {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-history i {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-history p {
  font-size: 14px;
  margin: 0;
}

/* 文本检测历史表格样式 */
.table-text-preview {
  font-size: 13px;
  color: #374151;
  line-height: 1.6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-word-count {
  font-size: 14px;
  color: #10b981;
  font-weight: 600;
}

.table-aigc-percent {
  font-size: 14px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}

.table-aigc-percent.percent-high {
  color: #ef4444;
  background: #fee2e2;
}

.table-aigc-percent.percent-mid {
  color: #f59e0b;
  background: #fef3c7;
}

.table-aigc-percent.percent-low {
  color: #10b981;
  background: #d1fae5;
}

/* 文件检测历史列表样式 */
.history-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.history-item {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
}

.history-item:hover {
  border-color: #4f46e5;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.1);
}

.history-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}

.history-item-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.history-time {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}

.history-filename {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.history-words {
  font-size: 13px;
  color: #10b981;
  font-weight: 600;
}

.history-aigc {
  font-size: 13px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}

.history-aigc.percent-high {
  color: #ef4444;
  background: #fee2e2;
}

.history-aigc.percent-mid {
  color: #f59e0b;
  background: #fef3c7;
}

.history-aigc.percent-low {
  color: #10b981;
  background: #d1fae5;
}

.history-item-actions {
  display: flex;
  gap: 8px;
}

.history-file-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6b7280;
}

.stat-item i {
  font-size: 14px;
  color: #4f46e5;
}
</style>
